import { createAction, props } from "@ngrx/store";
import { ScenarioCommand } from "src/components/shared-components/interfaces/iScenarios";
import { ScenariosCommandsStoreAction } from "src/components/shared-components/enum/enumStoreAction";

/**
 * Scenarios commands unset state and update storage key
 */
export const scenariosCommandsUnsetKeyStorageAction = createAction(
    ScenariosCommandsStoreAction.SCENARIOS_COMMANDS_UNSET_KEY_STORAGE
);

/**
 * Action fired when request to load start for a given scenario
 */
export const scenariosCommandsLoadInitStartAction = createAction(
    ScenariosCommandsStoreAction.SCENARIOS_COMMANDS_LOAD_INIT_START,
    props<{ idScenario: number }>()
);

/**
 * Action to load commands list for a given scenario from API
 */
export const scenariosCommandsLoadFromApiAction = createAction(
    ScenariosCommandsStoreAction.SCENARIOS_COMMANDS_LOAD_FROM_API,
    props<{ idScenario: number }>()
);

/**
 * Action fired when commands for a given scenario have been loaded successfully
 */
export const scenariosCommandsLoadSuccessAction = createAction(
    ScenariosCommandsStoreAction.SCENARIOS_COMMANDS_LOAD_SUCCESS,
    props<{ idScenario: number; commands: ScenarioCommand[] }>()
);

/**
 * Action fired when commands load fails. The HTTP status code is forwarded so that
 * components can react on the specific error code.
 */
export const scenariosCommandsLoadErrorAction = createAction(
    ScenariosCommandsStoreAction.SCENARIOS_COMMANDS_LOAD_ERROR,
    props<{ idScenario: number; errorCode: number }>()
);

/**
 * A command insert/update/delete has been notified by the broker for a given scenario.
 * The mutation itself is performed by the page through the service (direct API call);
 * this action is the MQTT-driven trigger that keeps the store in sync, mirroring the
 * scenario slice. clientID identifies the client that originated the change.
 */
export const scenariosCommandsChangeReceivedAction = createAction(
    ScenariosCommandsStoreAction.SCENARIOS_COMMANDS_CHANGE_RECEIVED,
    props<{ idScenario: number; clientID: string }>()
);

/**
 * A command has been deleted by the acting client: remove it from the store list
 * locally, without a full reload from API (there is no single-command GET, so a
 * granular local removal mirrors the scenario slice and avoids a needless request).
 */
export const scenariosCommandDeletedAction = createAction(
    ScenariosCommandsStoreAction.SCENARIOS_COMMAND_DELETED,
    props<{ idScenario: number; idCommand: number }>()
);
